import React from 'react';
import { FC } from 'react';

export const ZakekeLoadingIcon: FC<{ className?: string }> = ({ className }) => (
    <svg
        style={{ shapeRendering: 'geometricPrecision' }}
        xmlns='http://www.w3.org/2000/svg'
        display='block'
        width='207px'
        height='207px'
        viewBox='0 0 100 100'
        preserveAspectRatio='xMidYMid'
        className={className}
    >
        <circle cx='84' cy='50' r='10' fill='#567683'>
            <animate
                attributeName='r'
                repeatCount='indefinite'
                dur='0.641025641025641s'
                calcMode='spline'
                keyTimes='0;1'
                values='10;0'
                keySplines='0 0.5 0.5 1'
                begin='0s'
            ></animate>
            <animate
                attributeName='fill'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='discrete'
                keyTimes='0;0.25;0.5;0.75;1'
                values='#567683;#e6007e;#afcb08;#f07d00;#567683'
                begin='0s'
            ></animate>
        </circle>
        <circle cx='16' cy='50' r='10' fill='#567683'>
            <animate
                attributeName='r'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='0;0;10;10;10'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='0s'
            ></animate>
            <animate
                attributeName='cx'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='16;16;16;50;84'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='0s'
            ></animate>
        </circle>
        <circle cx='50' cy='50' r='10' fill='#f07d00'>
            <animate
                attributeName='r'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='0;0;10;10;10'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-0.641025641025641s'
            ></animate>
            <animate
                attributeName='cx'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='16;16;16;50;84'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-0.641025641025641s'
            ></animate>
        </circle>
        <circle cx='84' cy='50' r='10' fill='#afcb08'>
            <animate
                attributeName='r'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='0;0;10;10;10'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-1.282051282051282s'
            ></animate>
            <animate
                attributeName='cx'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='16;16;16;50;84'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-1.282051282051282s'
            ></animate>
        </circle>
        <circle cx='16' cy='50' r='10' fill='#e6007e'>
            <animate
                attributeName='r'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='0;0;10;10;10'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-1.923076923076923s'
            ></animate>
            <animate
                attributeName='cx'
                repeatCount='indefinite'
                dur='2.564102564102564s'
                calcMode='spline'
                keyTimes='0;0.25;0.5;0.75;1'
                values='16;16;16;50;84'
                keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
                begin='-1.923076923076923s'
            ></animate>
        </circle>
    </svg>
);
